import React, { useMemo, useState } from 'react';
import {
  certifyStatus,
  configNumberInputs,
  configs,
  coordinatesSource,
  inputNumber,
} from '../../../../../../Utils/data';
import {
  Input,
  Select,
  Space,
  Switch,
  Button,
  Spin,
  InputNumber,
  Row,
  Col,
  Card,
  Tooltip,
  Flex,
  Divider,
  Grid,
} from 'antd';
import { useUserData } from '../../../../../../Hooks/TT_ELD/Users';
import { useParams } from 'react-router-dom';
import { Field, Form } from 'react-final-form';
import { users } from '../../../../../../API/TT_ELD/Users/user';
import { sendEvent } from '../../../../../../Utils/analytics';
import { InfoCircleOutlined } from '@ant-design/icons';
import { isWhiteLabelAdmin } from '../../../../../../Utils/whiteLabel';

const { Option } = Select;
type MyObjectType = {
  [key: string | number]: any;
};

interface Params {
  id: string | undefined;

  [key: string]: string | undefined;
}

type Data = {
  data: any;
  isLoading?: boolean;
  refetch(): void;
};
const Config = () => {
  const CustomTooltipContent = ({ html }: { html: any }) => (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );

  const { useBreakpoint } = Grid;

  const isWhiteLabel = isWhiteLabelAdmin();

  // Config() ichida:
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const col4 = { xs: 24, sm: 12, md: 6, lg: 6 };
  const col6 = { xs: 24, sm: 12, md: 8, lg: 8 };
  const col8 = { xs: 24, sm: 24, md: 12, lg: 12 };
  const col12 = { xs: 24, sm: 24, md: 24, lg: 24 };

  const featureCardStyle: React.CSSProperties = {
    width: isMobile ? '100%' : 330,
  };

  const [customKey, setCustomKey] = useState('');
  const [customValue, setCustomValue] = useState<any>('');
  const [customType, setCustomType] = useState<'string' | 'number' | 'boolean' | 'clear'>('string');
  const [configType, setConfigType] = useState('config');
  const { id } = useParams<Params>();
  const { data, isLoading, refetch } = useUserData(id);
  const [loadings, setLoadings] = useState<boolean[]>([]);
  const [arrow, setArrow] = useState('Show');
  const mergedArrow = useMemo(() => {
    if (arrow === 'Hide') {
      return false;
    }
    if (arrow === 'Show') {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);
  const getCommand = async (command: string) => {
    await users.command(data.id, command);
    enterLoading(1);
    refetch();
  };

  const enterLoading = (index: number) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });

    setTimeout(() => {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }, 6000);
  };

  const onSubmit = async (values: any) => {
    let hasCustomKey = false;

    if (customKey.trim()) {
      let parsed: any = customValue;

      if (customType === 'number') parsed = Number(customValue);
      if (customType === 'boolean') {
        parsed = customValue === true || customValue === 'true' || customValue === '1';
      }

      if (customType === 'clear') {
        if (configType === 'settings') {
          delete values.settings[customKey.trim()];
        } else {
          delete values.config[customKey.trim()];
        }
      } else {
        if (configType === 'settings') {
          values.settings = {
            ...(values.settings || {}),
            [customKey.trim()]: parsed,
          };
        } else {
          values.config = {
            ...(values.config || {}),
            [customKey.trim()]: parsed,
          };
        }
      }

      hasCustomKey = true;
    }

    const body: MyObjectType = {};
    let key: string | number;
    let key2: string | number;

    for (key in values) {
      if (typeof data[key] === 'object' && !Array.isArray(data[key]) && data[key] != null) {
        for (key2 in values[key]) {
          if (data[key][key2] != values[key][key2]) {
            body[key] = values[key];
            break;
          }
        }
      } else if (data[key] != values[key]) {
        body[key] = values[key];
      }
    }

    if (hasCustomKey && !body.config) {
      body.config = values.config;
    }

    if (hasCustomKey && !body.settings) {
      body.settings = values.settings;
    }

    await users.userDataPatch(id, body);
    sendEvent('Config Tab ', `Config ${JSON.stringify(values)} `, 'Config Click ', 1);
    refetch();
  };

  return data ? (
    <Card>
      {data?.role !== 'dispatcher' && !isWhiteLabel && (
        <>
          <Card style={{ marginBottom: 20 }}>
            <Divider orientation="left" orientationMargin="0">
              Custom Config
            </Divider>

            <Row gutter={[16, 16]}>
              <Col {...col4}>
                <label>Config type</label>
                <Select
                  value={configType}
                  onChange={(value) => {
                    setConfigType(value);
                  }}
                  style={{ width: '100%' }}
                >
                  <Select.Option value="settings">Setting</Select.Option>
                  <Select.Option value="config">Config</Select.Option>
                </Select>
              </Col>
              <Col {...col4}>
                <label>Input type</label>
                <Select
                  value={customType}
                  onChange={(value) => {
                    setCustomType(value);

                    setCustomValue(value === 'boolean' ? false : '');
                  }}
                  style={{ width: '100%' }}
                >
                  <Select.Option value="string">String</Select.Option>
                  <Select.Option value="number">Number</Select.Option>
                  <Select.Option value="boolean">Boolean</Select.Option>
                  <Select.Option value="clear">Clear</Select.Option>
                </Select>
              </Col>
              <Col {...col8}>
                <label>Key</label>
                <Input
                  placeholder="config key"
                  value={customKey}
                  onChange={(e) => setCustomKey(e.target.value)}
                />
              </Col>

              <Col {...col8}>
                <label>Value</label>

                {/* TYPE-BASED INPUT */}
                {customType === 'string' && (
                  <Input
                    placeholder="value"
                    value={customValue}
                    onChange={(e) => setCustomValue(e.target.value)}
                  />
                )}

                {customType === 'number' && (
                  <InputNumber
                    style={{ width: '100%' }}
                    placeholder="value (number)"
                    value={customValue}
                    onChange={(v) => setCustomValue(v)}
                  />
                )}

                {customType === 'boolean' && (
                  <div style={{ display: 'flex', alignItems: 'center', height: 32 }}>
                    <Switch checked={Boolean(customValue)} onChange={(v) => setCustomValue(v)} />
                  </div>
                )}
                {customType === 'clear' && (
                  <div style={{ display: 'flex', alignItems: 'center', height: 32 }}>
                    <InputNumber
                      style={{ width: '100%' }}
                      placeholder="Return to the default value"
                      disabled
                    />
                  </div>
                )}
              </Col>
            </Row>
          </Card>
        </>
      )}

      <Form
        key={data?.id}
        onSubmit={onSubmit}
        initialValues={data}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
              {data?.role === 'dispatcher' && (
                <div
                  className="config_tabs"
                  style={{
                    display: 'flex',
                    gap: 12,
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                  }}
                >
                  {/*Pro features*/}
                  <Card style={featureCardStyle}>
                    <Flex gap="middle" vertical>
                      <Divider orientation="left">Pro features</Divider>
                      {configs
                        .filter(
                          (config) =>
                            config.group === 'pro_features' &&
                            !(isWhiteLabel && config.hideForWhiteLabel),
                        )
                        .map((config, index) => {
                          return (
                            data?.role === config.case && (
                              <Col key={index}>
                                <Field
                                  name={`config.${config.name}`}
                                  render={({ input }) => (
                                    <Switch
                                      defaultChecked={input.value || config?.defaultChecked}
                                      onChange={input.onChange}
                                    />
                                  )}
                                />
                                <label style={{ marginLeft: '15px' }}>
                                  {config.label}
                                  {config?.title && (
                                    <Tooltip
                                      placement="rightTop"
                                      title={<CustomTooltipContent html={config?.title} />}
                                      arrow={mergedArrow}
                                    >
                                      <InfoCircleOutlined
                                        style={{ marginLeft: '15px', cursor: 'pointer' }}
                                      />
                                    </Tooltip>
                                  )}
                                </label>
                              </Col>
                            )
                          );
                        })}
                    </Flex>
                  </Card>
                  {/* Sidebar Menu Pages */}

                  {/* <Card style={{ width: '330px' }}>
                    <Flex gap="middle" vertical>
                      <Divider orientation="left">Pages</Divider>
                      {configs
                        .filter((config) => config.group === 'sidebarMenuPages')
                        .map((config, index) => {
                          return (
                            data?.role === config.case && (
                              <Col key={index}>
                                <Field
                                  name={`config.${config.name}`}
                                  render={({ input }) => (
                                    <Switch
                                      defaultChecked={input.value || config?.defaultChecked}
                                      onChange={input.onChange}
                                    />
                                  )}
                                />
                                <label style={{ marginLeft: '15px' }}>
                                  {config.label}
                                  {config?.title && (
                                    <Tooltip
                                      placement="rightTop"
                                      title={<CustomTooltipContent html={config?.title} />}
                                      arrow={mergedArrow}
                                    >
                                      <InfoCircleOutlined
                                        style={{ marginLeft: '15px', cursor: 'pointer' }}
                                      />
                                    </Tooltip>
                                  )}
                                </label>
                              </Col>
                            )
                          );
                        })}
                    </Flex>
                  </Card> */}
                  {!isWhiteLabel && (
                    <Card style={featureCardStyle}>
                      <Flex gap="middle" vertical>
                        <Divider orientation="left">Reports</Divider>
                        {configs
                          .filter((config) => config.group === 'reports')
                          .map((config, index) => {
                            return (
                              data?.role === config.case && (
                                <Col key={index}>
                                  <Field
                                    name={`config.${config.name}`}
                                    render={({ input }) => (
                                      <Switch
                                        defaultChecked={input.value || config?.defaultChecked}
                                        onChange={input.onChange}
                                      />
                                    )}
                                  />
                                  <label style={{ marginLeft: '15px' }}>
                                    {config.label}
                                    {config?.title && (
                                      <Tooltip
                                        placement="rightTop"
                                        title={<CustomTooltipContent html={config?.title} />}
                                        arrow={mergedArrow}
                                      >
                                        <InfoCircleOutlined
                                          style={{ marginLeft: '15px', cursor: 'pointer' }}
                                        />
                                      </Tooltip>
                                    )}
                                  </label>
                                </Col>
                              )
                            );
                          })}
                      </Flex>
                    </Card>
                  )}
                </div>
              )}
              {data?.role !== 'dispatcher' && (
                <>
                  <Card>
                    <Row gutter={[16, 16]}>
                      {configs
                        .filter((config) => config.group === 'driver')
                        .map((config, index) => (
                          <Col {...col6} key={config.name}>
                            <Field
                              name={`config.${config.name}`}
                              render={({ input }) => {
                                const checked =
                                  input.value === undefined
                                    ? (config.defaultChecked ?? false)
                                    : input.value;

                                return (
                                  <>
                                    <Switch checked={checked} onChange={input.onChange} />
                                    <label style={{ marginLeft: 10 }}>
                                      {config.label}
                                      {config.title && (
                                        <Tooltip title={config.title} placement="rightTop">
                                          <InfoCircleOutlined
                                            style={{ marginLeft: 8, cursor: 'pointer' }}
                                          />
                                        </Tooltip>
                                      )}
                                    </label>
                                  </>
                                );
                              }}
                            />
                          </Col>
                        ))}
                    </Row>
                  </Card>
                </>
              )}

              {data?.role !== 'dispatcher' && (
                <>
                  <Card>
                    <Row gutter={[16, 16]}>
                      {inputNumber.map((u, index) => {
                        return (
                          <Col {...col6} key={u.name}>
                            <div>
                              <label>{u.label}</label>
                              <Field
                                name={`config.${u.name}`}
                                render={({ input }: { input: any }) => {
                                  const defaultValue =
                                    input?.value == null ? input?.value : u.defaultValue;
                                  return (
                                    <InputNumber
                                      title={u.title}
                                      style={{ width: '100%' }}
                                      placeholder={u.label}
                                      {...input}
                                      defaultValue={defaultValue}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </Col>
                        );
                      })}
                      <Col {...col6}>
                        <div>
                          <label>Certify status</label>
                          <Field
                            name="config.certify_status"
                            render={({ input }: { input: any }) => (
                              <Select
                                defaultValue={input.value}
                                onChange={(value, option) => {
                                  input.onChange(value);
                                }}
                                style={{ width: '100%' }}
                              >
                                {certifyStatus.map((data, index) => (
                                  <Option key={data.id}>{data.name}</Option>
                                ))}
                              </Select>
                            )}
                          />
                        </div>
                      </Col>
                      <Col {...col6}>
                        <div>
                          <label>Coordinates source</label>
                          <Field
                            name="config.coordinates_source"
                            render={({ input }: { input: any }) => (
                              <Select
                                defaultValue={input.value}
                                onChange={(value, option) => {
                                  input.onChange(value);
                                }}
                                style={{ width: '100%' }}
                              >
                                {coordinatesSource.map((data, index) => (
                                  <Option key={data.id}>{data.name}</Option>
                                ))}
                              </Select>
                            )}
                          />
                        </div>
                      </Col>
                      <Col {...col6}>
                        <div>
                          <label>Tracking source</label>
                          <Field
                            name="config.tracking_source"
                            render={({ input }: { input: any }) => (
                              <Select
                                defaultValue={input.value}
                                onChange={(value, option) => {
                                  input.onChange(value);
                                }}
                                style={{ width: '100%' }}
                              >
                                {coordinatesSource.map((data) => (
                                  <Option key={data.id}>{data.name}</Option>
                                ))}
                              </Select>
                            )}
                          />
                        </div>
                      </Col>
                      <Col {...col6}>
                        <div>
                          <label>Disable Log File</label>
                          <Field
                            name="config.ignoreLogWrite"
                            render={({ input }: { input: any }) => {
                              const currentValueArray = (input.value || '')
                                .toString()
                                .split(',')
                                .map((s: string) => s.trim())
                                .filter((s: string) => s.length > 0);

                              return (
                                <Select
                                  mode="multiple"
                                  allowClear
                                  placeholder="Select logs to disable"
                                  value={currentValueArray}
                                  onChange={(value: string[]) => {
                                    if (!value || value.length === 0) {
                                      input.onChange('');
                                    } else {
                                      input.onChange(value.join(','));
                                    }
                                  }}
                                  style={{ width: '100%' }}
                                >
                                  <Option value="api">API</Option>
                                  <Option value="eld">ELD</Option>
                                  <Option value="action">Action</Option>
                                  <Option value="error">Error</Option>
                                </Select>
                              );
                            }}
                          />
                        </div>
                      </Col>
                      {configNumberInputs.map((u, index) => {
                        return (
                          <Col {...col6} key={index}>
                            <label>{u.label}: </label>
                            <Field
                              name={u.name}
                              render={({ input }: { input: any }) => (
                                <Input placeholder={u.label} type="number" {...input} />
                              )}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Card>
                </>
              )}
            </Space>
            <div style={{ display: 'flex', marginTop: 20 }}>
              <Button
                style={{ marginRight: 15 }}
                type="primary"
                htmlType="submit"
                loading={loadings[0]}
                onClick={() => enterLoading(0)}
              >
                Submit
              </Button>
              {data.role === 'driver' && (
                <Button
                  loading={loadings[1]}
                  type="primary"
                  onClick={() => getCommand('update_user_info')}
                >
                  UPDATE USER INFO
                </Button>
              )}
            </div>
          </form>
        )}
      />
    </Card>
  ) : (
    <Spin size="large" spinning={isLoading}></Spin>
  );
};

export default Config;
